/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

// ---- Close ONLY the Quickshop tooltip when UpCart opens (and move focus) ----
(function () {
  function closeQuickshopIfOpen() {
    // Find any open tooltips
    const openTips = document.querySelectorAll('tool-tip[data-tool-tip-open="true"]')

    openTips.forEach((tip) => {
      // Heuristic: Quickshop tooltips contain a product form / buy buttons
      if (tip.querySelector('block-buy-buttons, .product-single__form')) {
        if (typeof tip._close === 'function') tip._close()
      }
    })

    // Accessibility: shift focus into the cart drawer if present
    const upcart = document.querySelector('.styles_CartPreview__')
    if (upcart) {
      if (!upcart.hasAttribute('tabindex')) upcart.setAttribute('tabindex', '-1')
      upcart.focus()
    }
  }

  // Listen for UpCart’s public event (you saw this in your console logs)
  window.addEventListener('aftersell-upcart:public-events:cart-opened', closeQuickshopIfOpen)
})();
// ---- End fix ----

// ---- Lock testimonials height permanently (no bounce) ----
(function () {
  function lockTestimonialHeight() {
    document.querySelectorAll('.testimonials-slider').forEach(slider => {
      const flkty = window.Flickity && Flickity.data(slider)
      if (!flkty || !flkty.viewport) return

      let maxHeight = 0

      flkty.slides.forEach(slide => {
        const cell = slide.cells && slide.cells[0]
        if (!cell || !cell.element) return

        // Measure VISUAL height (accounts for scale)
        const rect = cell.element.getBoundingClientRect()
        maxHeight = Math.max(maxHeight, rect.height)
      })

      if (maxHeight > 0) {
        // 1️⃣ Lock the height
        flkty.viewport.style.height = `${Math.ceil(maxHeight)}px`

        // 2️⃣ Disable adaptive height going forward
        flkty.options.adaptiveHeight = false
      }
    })
  }

  document.addEventListener('page:loaded', lockTestimonialHeight)

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', lockTestimonialHeight)
  }
})();
// ---- End testimonials height lock ----


// ---- MORE MENU (FINAL STABLE VERSION) ----
(function () {
  function setupMoreMenu() {
    const nav = document.querySelector('.kg-header-desktop-nav');
    const moreItem = document.querySelector('.site-nav__item--more');
    const moreDropdown = document.querySelector('.more-menu-dropdown');

    if (!nav || !moreItem || !moreDropdown) return;

    const items = Array.from(nav.querySelectorAll('.js-menu-item'));

    // Reset
    items.forEach(item => {
      item.style.display = '';
    });
    moreDropdown.innerHTML = '';

    //new code to ensure more button has measurable width
    moreItem.hidden = false;
    moreItem.style.display = 'block';

    let navWidth = nav.offsetWidth - 20;
    let usedWidth = moreItem.offsetWidth -50;

    items.forEach(item => {
      usedWidth += item.offsetWidth;

      if (usedWidth > navWidth) {
        // Extract only main link
        const linkEl =
          item.querySelector('summary[data-link]') ||
          item.querySelector(':scope > a');

        if (linkEl) {
          const li = document.createElement('li');
          const newLink = document.createElement('a');

          newLink.href =
            linkEl.dataset.link ||
            linkEl.getAttribute('href') ||
            '#';
          newLink.textContent = linkEl.textContent.trim();
          newLink.className = 'site-nav__dropdown-link';

          li.appendChild(newLink);
          moreDropdown.appendChild(li);
        }

        // Hide original item
        item.style.display = 'none';
      }
    });

    // Hide MORE if empty
    moreItem.hidden = !moreDropdown.children.length;
    moreItem.style.display = moreDropdown.children.length ? 'block' : 'none';
    }

    function runMoreMenu() {
      requestAnimationFrame(() => {
        setupMoreMenu();
      });
    }

    
  //commenting this out in order to stop visible wrap & overflow
  //function runMoreMenu() {
    // Run multiple times to stabilize layout
    //setTimeout(setupMoreMenu, 100);
    //setTimeout(setupMoreMenu, 300);
    //setTimeout(setupMoreMenu, 600);
  //}

 //new code to prevent visible wrap
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runMoreMenu);
  } else {
    runMoreMenu();
  }


  document.addEventListener('page:loaded', runMoreMenu);
  window.addEventListener('load', runMoreMenu);
  window.addEventListener('resize', setupMoreMenu);

  // Shopify editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', runMoreMenu);
  }

  // close more menu when mouse leaves the area
  const moreDetails = document.querySelector('.site-nav__item--more details');

  if (moreDetails) {
    moreDetails.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!moreDetails.matches(':hover')) {
          moreDetails.removeAttribute('open');
        }
      }, 100);
    });
  }
  
})();
// ---- END MORE MENU ----

//----- Images in Product Accordion Tabs ---

document.addEventListener('DOMContentLoaded', () => {
  const resizeOpenProductTabs = () => {
    document.querySelectorAll('.product-block--tab [aria-expanded="true"]').forEach((button) => {
      const tabId = button.getAttribute('aria-controls');
      if (!tabId) return;

      const content = document.getElementById(tabId);
      if (!content) return;

      const currentHeight = content.offsetHeight;

      content.style.height = '';
      const newHeight = content.scrollHeight;

      content.style.height = `${currentHeight}px`;

      requestAnimationFrame(() => {
        content.style.height = `${newHeight}px`;
      });
    });
  };

  window.addEventListener('resize', resizeOpenProductTabs);

  document.querySelectorAll('.product-tab__image img').forEach((img) => {
    img.addEventListener('load', resizeOpenProductTabs);
  });
});

// ---- End Images in Product Accordion Tabs